export default __webpack_public_path__ + "static/media/history.171f753a.svg";